export default "/img/RW.3904aa8c60fcd7915cfc4b7a8a8c5886.png";